export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  URL: string;
  UUID: string;
};

/** Ansprechpartner, auf den Partner bei Fragen zugehen können */
export type AnsprechPartner = {
  __typename: 'AnsprechPartner';
  /** URL zum Profilbild des Ansprechpartners */
  bildUrl: Maybe<Scalars['URL']>;
  /** Handelt es sich um den primären Ansprechpartner */
  istPrimaererKontakt: Scalars['Boolean'];
  /** Kundendivision, für die der Ansprechpartner zuständig ist */
  kundendivision: Maybe<Kundendivision>;
  /** Mailadresse des Ansprechpartners */
  mailadresse: Scalars['String'];
  /** Nachname des Ansprechpartners */
  nachname: Scalars['String'];
  /** Telefonnummer des Ansprechpartners */
  telefonnummer: Maybe<Scalars['String']>;
  /** Position/Rolle/Abteilung des Ansprechpartners */
  titel: Scalars['String'];
  /** Vorname des Ansprechpartners */
  vorname: Scalars['String'];
};

/** Ergebnis einer Operation */
export type EinzelErgebnis = {
  __typename: 'EinzelErgebnis';
  /** Die Ausführung war erfolgreich */
  erfolgreich: Scalars['Boolean'];
  /** Fehlermeldung */
  fehler: Maybe<Scalars['String']>;
  /** Id der Entität */
  id: Scalars['UUID'];
};

/** Fachlicher Schlüssel einer Kundendivision für einen Mandanten */
export type FachlicheId = {
  __typename: 'FachlicheId';
  /** Kundendivision, die den fachlichen Schlüssel nutzt */
  kundendivision: Kundendivision;
  /** Name des Schlüssels */
  name: Scalars['String'];
  /** Wert des Schlüssels */
  wert: Scalars['String'];
};

export type FachlicheIdInput = {
  kundendivision: Kundendivision;
  name: Scalars['String'];
  wert: Scalars['String'];
};

/** Fachlicher Schlüssel einer Kundendivision für einen Mandanten */
export type FachlicheIdMutationInput = {
  fachlicheIdInputs: Array<FachlicheIdInput>;
  organisationId: Scalars['UUID'];
};

/** Die Kundendivisionen von Team Beverage mit denen Kundenorganisationen in Geschäftsbeziehung stehen können */
export enum Kundendivision {
  /** Einzelhandel */
  Einzelhandel = 'EINZELHANDEL',
  /** Getränkefachgroßhandel */
  Grosshandel = 'GROSSHANDEL',
  /** Solution */
  Solution = 'SOLUTION',
  /** Team Business IT */
  TeamBusinessIt = 'TEAM_BUSINESS_IT'
}

/** Informationen zu einem Mandanten der Plattform. */
export type Mandant = {
  __typename: 'Mandant';
  /** Bezeichnung der Organisation für die Anzeige in den Apps der Plattform */
  anzeigename: Scalars['String'];
  /** Fachliche Ids zur Identifikation in externen Systemen */
  fachlicheIds: Array<FachlicheId>;
  /** Vollständige Firmierung der Organisation für die Anschrift */
  firmierung: Scalars['String'];
  /** Gibt an, ob das Produkt "Sales Planner" für den Nutzer freigeschaltet ist. */
  hasSalesPlanner: Scalars['Boolean'];
  /** Id des Mandanten */
  id: Scalars['UUID'];
  /** ID der Organisation in Keycloak. */
  keycloakOrganisationId: Scalars['String'];
};

/** Mutations für Nutzer */
export type Mutation = {
  __typename: 'Mutation';
  /** Weist einem Mandanten weitere fachliche Ids zu */
  fachlicheMandantenIdsZuweisen: OrganisationId;
  /** Erstellt einen neuen Mandanten */
  mandantErstellen: OrganisationId;
  /**
   * Löscht Nutzer des Mandanten
   *
   *
   * **Returns:**
   * Ergebnis je Id
   */
  nutzerEntfernen: Array<EinzelErgebnis>;
  /**
   * Erstellt einen neuen Nutzer im Mandanten des Aufrufers und verschickt eine Mail mit der Aufforderung das
   * Passwort zu ändern falls die Identität noch nicht existiert.
   *
   *
   * **Returns:**
   * Informationen zum neuen Nutzer
   */
  nutzerErstellen: Nutzer;
  /**
   * Erstellt einen neuen Nutzer mit einem temporären Passwort
   *
   *
   * **Returns:**
   * Informationen zum neuen Nutzer
   */
  nutzerMitPasswortErstellen: Nutzer;
  /**
   * Weist einem Nutzer produktspezifischen Rollen zu.
   *
   *
   * **Returns:**
   * Informationen zum geänderten Nutzer
   */
  nutzerRollenZuweisen: Nutzer;
  partnerWechseln: Scalars['Boolean'];
  /**
   * Schaltet ein Produkt für einen Mandanten frei
   *
   *
   * **Returns:**
   * Informationen zum veränderten Mandanten
   */
  produktFuerMandantFreischalten: OrganisationId;
};


/** Mutations für Nutzer */
export type MutationFachlicheMandantenIdsZuweisenArgs = {
  fachlicheIds: Array<FachlicheIdInput>;
  id: Scalars['UUID'];
};


/** Mutations für Nutzer */
export type MutationMandantErstellenArgs = {
  fachlicheIds?: InputMaybe<Array<FachlicheIdInput>>;
  firmierung: Scalars['String'];
  name: Scalars['String'];
};


/** Mutations für Nutzer */
export type MutationNutzerEntfernenArgs = {
  ids: Array<Scalars['UUID']>;
};


/** Mutations für Nutzer */
export type MutationNutzerErstellenArgs = {
  nachname: Scalars['String'];
  nutzerkennung: Scalars['String'];
  produktRollen: Array<ProduktRollenZuweisungInput>;
  vorname: Scalars['String'];
};


/** Mutations für Nutzer */
export type MutationNutzerMitPasswortErstellenArgs = {
  mailadresse: Scalars['String'];
  mandantenFirmierung: Scalars['String'];
  nachname: Scalars['String'];
  nutzerkennung: Scalars['String'];
  produktRollen: Array<ProduktRollenZuweisungInput>;
  temporaeresPasswort: Scalars['String'];
  vorname: Scalars['String'];
};


/** Mutations für Nutzer */
export type MutationNutzerRollenZuweisenArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  mandantenFirmierung?: InputMaybe<Scalars['String']>;
  nutzerkennung?: InputMaybe<Scalars['String']>;
  produktRollen: Array<ProduktRollenZuweisungInput>;
};


/** Mutations für Nutzer */
export type MutationPartnerWechselnArgs = {
  mandantenId: Scalars['String'];
};


/** Mutations für Nutzer */
export type MutationProduktFuerMandantFreischaltenArgs = {
  mandantenFirmierung: Scalars['String'];
  produktName: Scalars['String'];
};

/** Informationen zu einem Benutzer der Plattform. */
export type Nutzer = {
  __typename: 'Nutzer';
  /** Id des Nutzers */
  id: Scalars['UUID'];
  /** Mailadresse des Nutzers als Kontaktadresse */
  mailadresse: Scalars['String'];
  /** Nachname des Nutzers */
  nachname: Scalars['String'];
  /** Name des Nutzers */
  name: Scalars['String'];
  /**
   * Name der Identität des Nutzers
   * Aktuell wird hierfür eine Mailadresse verwendet. Diese kann von der Mailadresse des Mitarbeiters abweichen.
   */
  nutzerkennung: Scalars['String'];
  /** Die Rollen des Nutzers */
  rollen: Array<Rolle>;
  /** Vorname des Nutzers */
  vorname: Scalars['String'];
};

/** Mögliche Felder nach denen sortiert werden kann */
export enum NutzerSortierung {
  /** Mailadresse des Nutzers */
  Mailadresse = 'MAILADRESSE',
  /** Nachname des Nutzers */
  Nachname = 'NACHNAME',
  /** Name der Identität des Nutzers */
  Nutzerkennung = 'NUTZERKENNUNG',
  /** Standard Sortierung */
  Standard = 'STANDARD',
  /** Vorname des Nutzers */
  Vorname = 'VORNAME'
}

/** Wrapper um die ID einer Organisation zurückzugeben. */
export type OrganisationId = {
  __typename: 'OrganisationId';
  id: Scalars['UUID'];
  keycloakId: Maybe<Scalars['UUID']>;
};

/** Enthält alle Rollen die (über die die API) zu einem Produkt gehören */
export type ProduktRolle = {
  __typename: 'ProduktRolle';
  /** Name für die Anzeige */
  anzeigeName: Scalars['String'];
  /** Identifikator der Rolle */
  bezeichnung: Scalars['String'];
  istEditierbar: Scalars['Boolean'];
  istSicherheitsrolle: Scalars['Boolean'];
  /** Produkt, das die Rolle definiert */
  produkt: Scalars['String'];
};

/** Enthält die Rollen, die einem Nutzer für ein Produkt zugewiesen werden. */
export type ProduktRollenZuweisungInput = {
  /** Name des Produkts für das Rollen zugewiesen werden */
  produkt: Scalars['String'];
  /** Die Rollen, die für das Produkt zugewiesen werden */
  rollen: Array<Scalars['String']>;
};

/** Queries für Ansprechpartner */
export type Query = {
  __typename: 'Query';
  ansprechPartner: Array<AnsprechPartner>;
  /**
   * Liefert Informationen zu einem Nutzer anhand seiner Id
   *
   *
   * **Returns:**
   * Informationen zu Mandanten
   */
  nutzer: Maybe<Nutzer>;
  /**
   * Liefert Informationen zu den Mandanten des Nutzers
   *
   *
   * **Returns:**
   * Informationen zu Mandanten
   */
  nutzerMandanten: Array<Mandant>;
  nutzerPartnerbetreuer: Array<Mandant>;
  /** Liefert seitenweise Informationen zu den Nutzern eines Mandanten. */
  nutzerSeitenweise: Array<Nutzer>;
  /**
   * Die Methode liefert alle Rollen.
   * Durch die Angabe eines Produktnamens können die Rollen für ein Produkt abgefragt werden.
   *
   *
   * **Returns:**
   * Produktspezifische Rollen
   */
  rollen: Array<ProduktRolle>;
  /**
   * Liefert Versionsinformationen zum Service
   *
   *
   * **Returns:**
   * Versionsinformationen
   */
  versionen: Versionsinformationen;
};


/** Queries für Ansprechpartner */
export type QueryAnsprechPartnerArgs = {
  nurPrimaereKontakte?: Scalars['Boolean'];
};


/** Queries für Ansprechpartner */
export type QueryNutzerArgs = {
  id: Scalars['UUID'];
};


/** Queries für Ansprechpartner */
export type QueryNutzerSeitenweiseArgs = {
  sortierrichtung?: Sortierrichtung;
  sortierung?: NutzerSortierung;
  suchbegriff?: InputMaybe<Scalars['String']>;
};

/** Produktspezifische Rolle */
export type Rolle = {
  __typename: 'Rolle';
  /** Name für die Anzeige */
  anzeigeName: Scalars['String'];
  /** Identifikator der Rolle */
  bezeichnung: Scalars['String'];
  /** Produkt, das die Rolle definiert */
  produkt: Scalars['String'];
};

/** Sortierreihenfolge */
export enum Sortierrichtung {
  /** Absteigende Sortierung */
  Absteigend = 'ABSTEIGEND',
  /** Aufsteigende Sortierung */
  Aufsteigend = 'AUFSTEIGEND'
}

/** Beschreibt die Version von Assemblies */
export type Versionsinformationen = {
  __typename: 'Versionsinformationen';
  apiVersion: Scalars['String'];
};
